import React, { Component } from "react";
import "./style.css";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";

import {
  formatNumbers,
  isNetworkRequestFailedError,
} from "../../config/helpers";
import api from "../../config/api";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import authAction from "../../redux/auth/action";
import staffDashboardAction from "../../redux/staffDashboard/action";
import bannerPopupActions from "../../redux/bannerPopup/action";
import FloatingButton from "../../component/FloatingButton";

class StaffDashboard extends Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    const { staffData } = this.props;
    if (!staffData) {
      this.setState({ isLoading: true });
      this.fetchData();
      this.showRoleConvertTextPopup();
    }
  }

  showRoleConvertTextPopup = () => {
    this.props.setBannerPopup({
      visible: true,
      title: "Message",
      message: [
        "To add additional role that will enable you view other dashboards.",
        "Kindly Contact customer service via --- csu@premiumpension.com, 09 461 5700-4, 09-7000020",
      ],
    });
  };

  fetchData = async () => {
    const { user, getStaffData, setAlertMessage } = this.props;

    try {
      const response = await api.fetchStaffData(
        { staffCode: user.User.staffCode },
        user.token
      );
      const data = response.data.result[0];
      getStaffData(data);
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? this.fetchData : null,
      });
    }
    this.setState({ isLoading: false });
  };

  navigateToReferral = () => {
    this.props.history.push("/referral");
  };

  render() {
    const { isLoading } = this.state;
    const { staffData } = this.props;

    return (
      <Container>
        {isLoading && <CustomLoader />}
        <PageHead title="STAFF DASHBOARD" containerStyles={{ width: "100%" }} />
        <div className="date-box mt-3">
          <p className="my-3">{moment().format("MMMM DD,YYYY")}</p>
        </div>
        {staffData && (
          <ul className="list-container">
            <li className="mt-n2">
              <span>Accounts</span>
              <span>{staffData.Total_Number_Of_Accounts}</span>
            </li>
            <li className="mt-2">
              <span>Funded Accounts</span>
              <span>{staffData.Total_Number_Of_Funded_Accounts}</span>
            </li>
            <li className="mt-2">
              <span>UnFunded Accounts</span>
              <span>{staffData.Total_Number_Of_UnFunded_Accounts}</span>
            </li>
            <li className="mt-2">
              <span>Balance</span>
              <span>{formatNumbers(staffData.Total_Account_Balance)}</span>
            </li>
            <li className="mt-2">
              <span>Units</span>
              <span>{formatNumbers(staffData.Total_Units)}</span>
            </li>
          </ul>
        )}
        <FloatingButton
          onClick={this.navigateToReferral}
          style={{ position: "absolute" }}
          position="BOTTOM_CENTER"
        >
          Referral
        </FloatingButton>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  staffData: state.staffDashboard.staffData,
});

const mapDispatchToProps = {
  setAlertMessage: authAction.setAlertMessage,
  getStaffData: staffDashboardAction.getStaffData,
  setBannerPopup: bannerPopupActions.setBannerPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(StaffDashboard);
